import QuestionObj from "./Models/QuestionObj";

export function addRolesToQuestionSet(
  QuestionSets,
  roles,
  questionAndAnswerSets
) {
  roles.map((role) => {
    QuestionSets[role] = createQuestionSetFromSchema(
      questionAndAnswerSets,
      role
    );
  });
}
//this is creating a single set by role using the full set from questionAndAnswerSets

export function createQuestionSetFromSchema(questionAndAnswerSets, role) {
  return questionAndAnswerSets[role].map((qObj) => {
    const { NegCopy: negCopy, NegLink: negLink, LinkText: negLinkText } = qObj;

    return new QuestionObj({
      ...qObj,
      negCopy,
      negLink,
      negLinkText,
    });
  });
}
